"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeadlinesInputFieldTypes = void 0;
const types_1 = require("../../types/types");
const is_product_1 = require("../is-product/is-product");
function getDeadlinesInputFieldTypes(products) {
    const result = [];
    if (products.some(is_product_1.isDirectMarketing)) {
        result.push(types_1.InputFieldType.PRODUCTION);
        if (products.some(is_product_1.isFCR)) {
            result.push(types_1.InputFieldType.FCR);
        }
        if (products.some(is_product_1.isFlexPlus)) {
            result.push(types_1.InputFieldType.FLEX_PLUS_UPPER_LIMIT);
            result.push(types_1.InputFieldType.FLEX_PLUS_LOWER_LIMIT);
        }
        if (products.some(is_product_1.isMFrrMinus) || products.some(is_product_1.isMFrrPlus)) {
            result.push(types_1.InputFieldType.MFRR_UPPER_LIMIT);
            result.push(types_1.InputFieldType.MFRR_LOWER_LIMIT);
        }
        if (products.some(is_product_1.isAFrrMinus) || products.some(is_product_1.isAFrrPlus)) {
            result.push(types_1.InputFieldType.AFRR_UPPER_LIMIT);
            result.push(types_1.InputFieldType.AFRR_LOWER_LIMIT);
        }
        return result;
    }
    if (products.some(is_product_1.isFCR)) {
        result.push(types_1.InputFieldType.FCR);
    }
    if (products.some(is_product_1.isMFrrMinus)) {
        result.push(types_1.InputFieldType.MFRR_NEGATIVE);
    }
    if (products.some(is_product_1.isMFrrPlus)) {
        result.push(types_1.InputFieldType.MFRR_POSITIVE);
    }
    if (products.some(is_product_1.isAFrrMinus)) {
        result.push(types_1.InputFieldType.AFRR_NEGATIVE);
    }
    if (products.some(is_product_1.isAFrrPlus)) {
        result.push(types_1.InputFieldType.AFRR_POSITIVE);
    }
    return result;
}
exports.getDeadlinesInputFieldTypes = getDeadlinesInputFieldTypes;
